import { jsx as _jsx } from "react/jsx-runtime";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import React from "react";
import { NotifyMeBackInStockButton } from "./NotifyMeButton";
import { useFaireProtection } from "@faire/retailer/stores/domain/FaireProtection/useFaireProtection";
export var NotifyMe = function(param) {
    var data = param.data;
    var isSalesPaused = data.productState === IProduct.State.SALES_PAUSED;
    var isBrandTokenForbidden = useFaireProtection().isBrandTokenForbidden;
    var _data_brandToken;
    var isFaireProtectionRestricted = isBrandTokenForbidden((_data_brandToken = data.brandToken) !== null && _data_brandToken !== void 0 ? _data_brandToken : "");
    if (!isSalesPaused || data.productOptionToken === undefined || isFaireProtectionRestricted) {
        return null;
    }
    return /*#__PURE__*/ _jsx(NotifyMeBackInStockButton, {
        productOptionToken: data.productOptionToken,
        productToken: data.productToken,
        productState: data.productState,
        isSubscribedToBackInStockNotification: data.isSubscribedToBackInStockNotification,
        brandToken: data.brandToken
    });
};
